export default __webpack_public_path__ + "static/MediaMainBanner-2be965694f89bb84ca7d4df03b5c59f1.webp";